const globals = {
    "currentSeason": "Spring Outdoor 2025"
};


export default globals;